import { IGoal } from "motw_core/Entity/IGoal";
import * as React from "react";
import { GoalEditor } from "source/app/presentation/MainPanel/Goals/GoalEditor/GoalEditor";
import Hyperlink from "source/app/presentation/Shared/Link/Hyperlink";
import RPGIcon, {
    GetRPGIcon,
} from "source/app/presentation/Shared/RPGIcon/RPGIcon";
import { ShowDailyGoalIcon } from "./ShowDailyGoalIcon";

export function ShowGoalIcon({ matchingGoal }: { matchingGoal?: IGoal }) {
    if (matchingGoal === undefined) {
        return null;
    }

    return (
        <Hyperlink whenClicked={() => GoalEditor(matchingGoal)}>
            <RPGIcon icon={GetRPGIcon(matchingGoal.icon)} />
            <ShowDailyGoalIcon {...{ matchingGoal }} />
        </Hyperlink>
    );
}

